import { z } from 'zod';
/** never = 만료 없음 (영구). at = 지정 시각 만료 (ISO datetime). */
export const ApiKeyExpirySchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('never') }),
    z.object({ kind: z.literal('at'), at: z.string().datetime() }),
]);
/** 평문 secret 은 절대 포함되지 않는 키 표현. 표시용 prefix 만 노출. */
export const ApiKeySchema = z.object({
    id: z.string().uuid(),
    ownerUserId: z.string().uuid(),
    ownerEmail: z.string().nullable(),
    ownerDisplayName: z.string().nullable(),
    name: z.string(),
    keyPrefix: z.string(),
    expiresAt: z.string().nullable(),
    lastUsedAt: z.string().nullable(),
    createdAt: z.string(),
    createdByUserId: z.string().uuid().nullable(),
    createdByEmail: z.string().nullable(),
    revokedAt: z.string().nullable(),
});
/** 발급 직후 1회만 평문 secret 포함. 이후 응답에는 다시 안 나타남. */
export const ApiKeyWithSecretSchema = ApiKeySchema.extend({
    secret: z.string(),
});
export const ApiKeyListSchema = z.object({
    keys: z.array(ApiKeySchema),
});
export const CreateApiKeyRequestSchema = z.object({
    name: z.string().min(1, '이름은 필수입니다.').max(80),
    expiry: ApiKeyExpirySchema,
    /** 관리자가 다른 사용자 명의로 발급할 때 사용. 일반 사용자 라우트에선 무시. 미지정 시 self. */
    ownerUserId: z.string().uuid().optional(),
});
export const ApiKeyScopeSchema = z.enum(['mine', 'all']);
export const ApiKeyListQuerySchema = z.object({
    /** 관리자만 'all' 사용 가능. 기본 'mine'. */
    scope: ApiKeyScopeSchema.default('mine'),
});
/** 사용량 1건 = 프록시 요청 1건. 토큰 정보 미상이면 null (vLLM 응답 형식 제각각). */
export const ApiKeyUsageItemSchema = z.object({
    id: z.string().uuid(),
    keyId: z.string().uuid().nullable(),
    keyName: z.string().nullable(),
    keyPrefix: z.string().nullable(),
    userId: z.string().uuid().nullable(),
    userEmail: z.string().nullable(),
    endpointPath: z.string(),
    model: z.string().nullable(),
    promptTokens: z.number().int().nullable(),
    completionTokens: z.number().int().nullable(),
    totalTokens: z.number().int().nullable(),
    statusCode: z.number().int(),
    durationMs: z.number().int(),
    error: z.string().nullable(),
    createdAt: z.string(),
});
export const ApiKeyUsageListSchema = z.object({
    items: z.array(ApiKeyUsageItemSchema),
    nextCursor: z.string().nullable(),
});
export const ApiKeyUsageQuerySchema = z.object({
    keyId: z.string().uuid().optional(),
    userEmail: z.string().optional(),
    /** 정확 매칭 (예: 200, 401, 403, 502). */
    statusCode: z.coerce.number().int().optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(10).max(100).default(50),
});
/** 관리자 'API 인증 관리' 화면 전용 settings. */
export const ApiKeySettingsSchema = z.object({
    /** 시스템 전역 LLM 릴레이 활성화 플래그. system_config 의 동명 컬럼과 1:1. */
    llmApiRelayEnabled: z.boolean(),
});
export const UpdateApiKeySettingsRequestSchema = z.object({
    llmApiRelayEnabled: z.boolean(),
});
export const ApiKeyUsageStatsSchema = z.object({
    totalRequests: z.number().int(),
    successRequests: z.number().int(),
    errorRequests: z.number().int(),
    totalTokens: z.number().int(),
});
//# sourceMappingURL=api-keys.js.map